import { useCallback, useRef } from 'react';
import moment from 'moment-timezone';
import {
  FormatParams,
  NowParams,
  IsBeforeParams,
  IsAfterParams,
} from './useDate.types';

export const useDate = () => {
  const { current: tz } = useRef(moment.tz.guess());

  const format = useCallback(
    ({ value, format = 'L' }: FormatParams = {}) => {
      return moment.tz(value, tz).format(format);
    },
    [tz]
  );

  const now = useCallback(({ format = 'iso' }: NowParams = {}) => {
    if (format === 'iso') {
      return moment().toISOString();
    }
    return moment().unix();
  }, []);

  const isBefore = useCallback(({ first, last }: IsBeforeParams) => {
    return moment(first).isBefore(last);
  }, []);

  const isAfter = useCallback(({ first, last }: IsAfterParams) => {
    return moment(last).isAfter(first);
  }, []);

  return { format, now, tz, date: moment, isBefore, isAfter };
};
